module.exports = __webpack_public_path__ + "assets/images/USDUNFIT50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDUNFIT50.png
// module id = 1471
// module chunks = 1